import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    mutation ($userId: Int!, $planCode: String!) {\n        setUserSubscriptionLevelByCode(userId: $userId, planCode: $planCode) {\n            ok\n            email\n            errors {\n                path\n                message\n            }\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
import { AccountClient, getLocalStorageWithExpiry
/* , log */
} from '@emyw/core-lib';
var FREE = process.env.REACT_APP_FREE_PLAN_CODE;
export var normalizeErrors = function normalizeErrors(errors, catchUnknownPathInto, forceUnknown) {
  var path = null;

  if (errors && errors.reduce) {
    return errors.reduce(function (acc, cv) {
      path = (cv.path === 'unknown' || forceUnknown) && catchUnknownPathInto ? catchUnknownPathInto : cv.path;

      if (path in acc) {
        acc[path].push(cv.message);
      } else {
        acc[path] = [cv.message];
      }

      return acc;
    }, {});
  }

  return errors || 'Unknown error';
};
export var getRootUrl = function getRootUrl() {
  return window.location.origin ? "".concat(window.location.origin, "/") : "".concat(window.location.protocol, "/").concat(window.location.host, "/");
};
var setUserSubscriptionLevelByCodeMutation = gql(_templateObject());
export var setUserSubscriptionLevelByCode = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId, planCode) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return AccountClient.mutate({
              mutation: setUserSubscriptionLevelByCodeMutation,
              variables: {
                userId: userId,
                planCode: planCode
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data.setUserSubscriptionLevelByCode);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              ok: false,
              errors: 'Network error: failed to update user subscription plan'
              /* error.message */

            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function setUserSubscriptionLevelByCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getPlanCostLabel = function getPlanCostLabel(user, defaultPlan, skipPeriod) {
  var _ref2 = user || {},
      subscriptionLevelCode = _ref2.subscriptionLevelCode,
      subscriptionLevelMonthlyCostFormatted = _ref2.subscriptionLevelMonthlyCostFormatted;

  if (!subscriptionLevelMonthlyCostFormatted && defaultPlan) {
    subscriptionLevelCode = defaultPlan.code;
    subscriptionLevelMonthlyCostFormatted = defaultPlan.monthlyCostFormatted;
  }

  if (!subscriptionLevelMonthlyCostFormatted) return '';
  var promoApplied = subscriptionLevelCode !== FREE; //  && getLocalStorageWithExpiry('enjoy-promo-code') === DEFAULT_PROMO_CODE;

  return {
    label1: "".concat(subscriptionLevelMonthlyCostFormatted, " + tax per month"),
    label2: "".concat(promoApplied ? ' after 7 day free trial' : '').concat(skipPeriod ? '' : '.')
  };
};
export var DEFAULT_PROMO_CODE = '7 DAYS FREE';